const actionTypes = {
  RECEIVE_CLASS_ENROLLMENTS:
    "seneca/enrollments/classes/RECEIVE_CLASS_ENROLLMENTS",
  RECEIVE_CLASS_ENROLLMENT:
    "seneca/enrollments/classes/RECEIVE_CLASS_ENROLLMENT",
  DELETE_CLASS_ENROLLMENT: "seneca/enrollments/classes/DELETE_CLASS_ENROLLMENT",
  RECEIVE_CHILD_CLASS_ENROLLMENTS:
    "seneca/child/enrollments/classes/RECEIVE_CHILD_CLASS_ENROLLMENTS"
};

export default actionTypes;
